import { AppShell } from "./app";
import { createRoot } from "react-dom/client";
import { bindAttributionCookie, captureAttribution } from "services/attribution";
import { bindConsent, initCookieConsent } from "services/cookieConsent";
import { initI18n } from "services/i18n";
import { configLogger } from "services/logging";
import { disableProductAnalytics, initProductAnalytics } from "services/productAnalytics";
import { initTagManager } from "services/tagManager";
import { captureUrlSecrets } from "services/payments/urlSecrets";
import assert from "utils/assert";
import { hydrateSessionStorage } from "utils/storage";

import "./styles/primitives.css";
import "./styles/semantic.css";
// Opt-in kit geometry for legacy native form markup inside ui/Dialog bodies —
// activate by adding `kit-form-controls` to a Dialog's className. Loaded here
// because kit components themselves must not import global stylesheets.
import "./components/ui/Dialog/formControls.css";
import "styles/index.css";

// Runs first so the address bar is clean of a link's secrets before Sentry records a
// navigation or any tag sees a page view.
captureUrlSecrets();
configLogger();

initI18n();
hydrateSessionStorage();
captureAttribution();

const container = document.getElementById("root");
assert(container, "Root container not found");
createRoot(container).render(<AppShell />);

// Consent Mode defaults must be on the data layer before Cookiebot loads.
initTagManager();
initCookieConsent();
bindConsent("statistics", initProductAnalytics, disableProductAnalytics);
bindAttributionCookie();
